export default [
  {
    path: "company-list",
    meta: {
      title: "companyList",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/MultiTenant/ManageCompany/ManageCompany",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "manage-license",
    meta: {
      title: "manageLicence",
      target: process.env.VUE_APP_AGMS_URL + "/MultiTenant/ManageLicense",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "install-package",
    meta: {
      title: "installPackage",
      target:
        process.env.VUE_APP_AGMS_URL +
        "/MultiTenant/Administrator/InstallPackageList",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "audit-viewer",
    meta: {
      title: "auditViewer",
      target: process.env.VUE_APP_AGMS_URL + "/MultiTenant/AuditViewer",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "add-publisher",
    meta: {
      title: "addPublisher",
      target: process.env.VUE_APP_AGMS_URL + "/MultiTenant/CompanyPublisher",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "global-role-policies",
    meta: {
      title: "globaRolePolicies",
      target: process.env.VUE_APP_AGMS_URL + "/MultiTenant/GlobalRolePolicy",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
  {
    path: "manage-company",
    meta: {
      title: "manageCompany",
      target: process.env.VUE_APP_AGMS_URL + "/MultiTenant/ManageCompany",
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
];
